export enum homeActionTypes {
    LEFTMENUTOGGLE = 'LEFTMENUTOGGLE',
    RIGHTMENUTOGGLE = 'RIGHTMENUTOGGLE',
    SETTINGMENUTOGGLE = 'SETTINGMENUTOGGLE',
    REQUESTSAVEDOCUMENT = 'REQUESTSAVEDOCUMENT',
    SUCCESSSAVEDOCUMENT = 'SUCCESSSAVEDOCUMENT',
    REQUESTGETMESSAGELIST = 'REQUESTGETMESSAGELIST',
    SUCCESSGETMESSAGELIST = 'SUCCESGETMESSAGELIST',
    ERRORGETMESSAGELIST = 'ERRORGETMESSAGELIST'
}
export interface HomeState {
    leftMenuStatus: boolean;
    rightMenuStatus: boolean;
    settingMenuStatus: boolean;
    saveDocument: boolean;
}

interface HomeToggleLeftMenuAction {
    type: homeActionTypes.LEFTMENUTOGGLE
}

interface HomeToggleRightMenuAction {
    type: homeActionTypes.RIGHTMENUTOGGLE
}

interface HomeToggleSettingMenuAction {
    type: homeActionTypes.SETTINGMENUTOGGLE
}

interface RequestSaveDocumentAction {
    type: homeActionTypes.REQUESTSAVEDOCUMENT
}

interface SuccessSaveDocumentAction {
    type: homeActionTypes.SUCCESSSAVEDOCUMENT
}

interface  RequestGetMessageList{
    type: homeActionTypes.REQUESTGETMESSAGELIST
}
 interface SuccessGetMessageList {
    type: homeActionTypes.SUCCESSGETMESSAGELIST
    payload: any;
}
interface ErrorGetMessageList {
    type: homeActionTypes.ERRORGETMESSAGELIST

}

export type HomeAction =
    HomeToggleLeftMenuAction  |
    HomeToggleRightMenuAction |
    HomeToggleSettingMenuAction |
    RequestSaveDocumentAction |
    SuccessSaveDocumentAction |
    RequestGetMessageList |
    SuccessGetMessageList |
    ErrorGetMessageList

